import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/projects/$id')({
  beforeLoad: ({ params }) => {
    throw redirect({ to: '/tasks/projects/$id', params });
  },
});
